import { render, staticRenderFns } from "./ContentAdmin.vue?vue&type=template&id=13af78a7&"
import script from "./ContentAdmin.vue?vue&type=script&lang=js&"
export * from "./ContentAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports